import { createReadonlyProvider } from 'apprise-frontend-core/state/factory'


export type EnvConfig = {

    name: 'development' | 'staging' | 'production' 
    version: string | undefined
}


export const  [Env, useEnv] = createReadonlyProvider<EnvConfig>({

     name: import.meta.env.PROD ? 'production' : 'development' 

})

